<template>
  <div class="materials-page">
    <div class="materials-page__header">
      <h1 class="materials-page__title" v-if="title">{{ title }}</h1>
      <h1 class="materials-page__title" v-else>{{ $tAccount('Useful materials') }}</h1>
      <!--      <div class="materials-page__category-wrap">-->
      <!--        <BaseSelect-->
      <!--          :value="currentCategory"-->
      <!--          :options="categories"-->
      <!--          :getOptionText="getOptionText"-->
      <!--          @input="onSelectInput"-->
      <!--          class="materials-page__category _white"-->
      <!--        />-->
      <!--      </div>-->
    </div>

    <MaterialTags v-if="tags" :tagsList="tags"/>

    <div class="materials-page__content">
      <BasePreloader v-if="pending"/>
      <div class="materials-page__content-list">
        <MaterialCard v-for="(item, index) in news"
                      :key="item.id"
                      :item="item"
                      :isBig="index === 0 && windowSizeMixin.width > 1023"
                      class="materials-page__card"/>
      </div>
    </div>

    <Pagination v-if="pagesCount > 1"
                :quantity="pagesCount"
                :withGoTo="false"
                class="vacancies-result__pagination"/>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import MaterialCard from '@/components/usefulMaterials/MaterialCard'
  import Pagination from '@/components/Pagination'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import MaterialTags from '@/components/usefulMaterials/MaterialTags'
  // const categories = ['Все категории', 'asdasdad', 'fasdaasd']

  export default {
    name: 'AccountUsefulMaterialsPage',
    components: {MaterialTags, Pagination, MaterialCard},
    mixins: [windowSizeMixin],
    props: {
      title: {
        type: String
      }
    },
    data() {
      return {
        // categories,
        pending: false,
        news: [],
        total: 0,
        perPage: 0,
        queryNamePage: 'page',
        queryParamsNames: ['page', 'tags'],
        tags: null
      }
    },
    computed: {
      // currentCategory() {
      //   return this.categories[0]
      // },
      pagesCount() {
        return Math.ceil(this.total / this.perPage) || 0
      },
      page() {
        return this.$route.query[this.queryNamePage] || 1
      },
      queryParams() {
        const params = {}

        for (let name of this.queryParamsNames) {
          let value = this.$route.query[name]
          if (value) {
            params[name] = value
          }
        }

        return params
      }
    },
    methods: {
      // getOptionText(option) {
      //   return this.$tAccount(option)
      // },
      // onSelectInput(value) {
      //   console.log(value)
      // }
      load() {
        this.pending = true

        http.get('/api/news', {
          params: this.queryParams
        }).then(({data}) => {
          const mainData = data.data
          const tags = data.tags

          if (mainData.last_page < mainData.current_page) {
            let page = mainData.last_page || 1
            this.$router.push({query: {...this.$route.query, [this.queryNamePage]: page}})
          } else {
            this.news = mainData.data
            this.total = mainData.total
            this.tags = tags
            this.perPage = mainData.per_page
          }
        }).finally(() => {
          this.pending = false
        })
      },
    },
    created() {
      this.load()
    },
    watch: {
     $route() {
       this.load()
     }
    }
  }
</script>

<style>

</style>
